/**
 * Design tokens taken from the Figma prototype "Centro de Notificaciones — Prototipo".
 *
 * Values the app theme already carries with the exact same hex are consumed from the theme
 * at the usage site (azure.main #3B82F6, azure.light #2563EB, grey[200] #E5E7EB,
 * grey[500] #6B7280, text.primary #0070C0). The rest live here because they are specific
 * to the notification surface and have no theme equivalent yet.
 */
export const NOTIFICATION_CARD_TOKENS = {
  // Surfaces
  unreadBg: '#EFF6FF', // --funnel-unread-bg
  unreadBorder: '#BFDBFE', // --funnel-unread-border
  surface: '#FFFFFF', // --funnel-surface
  border: '#E5E7EB', // --funnel-border
  borderInput: '#E5EAF2', // --funnel-border-input

  // Text
  text: '#020817', // --funnel-text
  textMuted: '#6B7280', // --funnel-text-muted
  textSubtle: '#64748B', // --funnel-text-subtle

  // Context pill
  pillUnreadBg: '#3B82F6', // --funnel-azure-main
  pillUnreadFg: '#FFFFFF',
  pillUnreadShadow: '0px 1px 2px 0px rgba(0, 0, 0, 0.3), 0px 2px 6px 2px rgba(0, 0, 0, 0.15)', // M3/Elevation Light/2
  pillReadBg: '#EFF6FF', // --funnel-status-cold-bg
  pillReadFg: '#2563EB', // --funnel-status-cold-fg

  // Score chip
  scoreBg: '#DCFCE7', // --funnel-status-qualified-bg
  scoreFg: '#16A34A', // --funnel-status-qualified-fg

  // Floating action bar (desktop hover)
  actionBarBg: 'rgba(23, 27, 53, 0.98)',
  actionBarBorder: 'rgba(255, 255, 255, 0.1)',
  actionBarShadow: '0px 6px 16px 0px rgba(9, 12, 23, 0.34)',
  actionBarFg: '#F8FAFD',
  actionBarButtonHoverBg: 'rgba(255, 255, 255, 0.1)',

  // Dark tooltip used by the floating action bar
  tooltipBg: '#171B35',
  tooltipBorder: 'rgba(255, 255, 255, 0.08)',
  tooltipFg: '#F8FAFD',

  // Tabs
  tabActiveBg: '#EFF6FF', // --funnel-unread-bg
  tabActiveFg: '#0070C0', // --funnel-azure-dark
  tabInactiveFg: '#64748B', // --funnel-text-subtle
} as const;

/**
 * The drawer already supplies 16px of horizontal padding (Paper `p: 1` + content `p: 1`).
 * The design places the tabs, toolbar and list 20px from the drawer edge, so every
 * notification-center section adds these remaining 4px to line up with the prototype.
 */
export const CONTENT_INSET_PX = 4;

/** Vertical gap between cards in the list (Figma: cards at y=28, 174, 320 → 12px). */
export const CARD_GAP_PX = 12;
